import isApiError from "@insite/client-framework/Common/isApiError";
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { OrderRejectionModel } from "@theStellarBlueprint/CustomApiModel";

const rejectedReasonAPI = "api/v1/Cart/SaveRejectedReason";

export async function POSTOrderRejectionReason(parameter: OrderRejectionModel): Promise<ServiceResult<any>> {
    try {
        const result = await post(rejectedReasonAPI, parameter);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error) && error?.status === 400 && error?.errorJson && error?.errorJson.message) {
            return {
                successful: false,
                errorMessage: error?.errorJson.message,
            };
        }
        throw error;
    }
}
